// 站点内容数据（mock）：更新资讯、口碑、FAQ、今日更新

export const todayUpdates = [
  { time: '07:30', title: '西风斩 第128话 已更新', tag: '热血', tagColor: 'primary' },
  { time: '09:15', title: '魔狱神宫 第203话 已更新', tag: '奇幻', tagColor: 'accent' },
  { time: '10:40', title: '斗擂谷 第188话 已更新', tag: '热血', tagColor: 'secondary' },
  { time: '13:05', title: '星界先锋 第97话 已更新', tag: '科幻', tagColor: 'primary' },
  { time: '15:20', title: '解读之书 汉化进度推进至85%', tag: '汉化', tagColor: 'secondary' },
  { time: '18:00', title: '情之迷记 第53话 已更新', tag: '恋爱', tagColor: 'accent' },
  { time: '20:30', title: '武魂之烬 第240话 已更新', tag: '热血', tagColor: 'primary' },
  { time: '22:10', title: '心理灵域 汉化进度推进至72%', tag: '汉化', tagColor: 'accent' },
];

export const latestNews = [
  {
    id: 'news-1',
    title: '策驰漫画网更新体系升级：同步更新进度实时可查',
    date: '08-18',
    category: '平台公告',
    excerpt: '本周起，平台升级漫画同步更新机制，热门连载的最新话与汉化进度将实时同步，追更不再错过任何一话。',
  },
  {
    id: 'news-2',
    title: '《魔狱神宫》汉化进度提速，每周一固定更新',
    date: '08-16',
    category: '连载速报',
    excerpt: '为保证追更体验，《魔狱神宫》团队调整汉化排期，新增多人协同，同步更新进度提升至 98%。',
  },
  {
    id: 'news-3',
    title: '新人作者扶持计划开启，欢迎投稿优秀作品',
    date: '08-12',
    category: '平台活动',
    excerpt: '为发掘更多优质原创内容，平台推出新人作者扶持计划，审核通过的作品将获得专属推荐位与流量扶持。',
  },
  {
    id: 'news-4',
    title: '移动端阅读体验优化，追更进度一目了然',
    date: '08-08',
    category: '功能更新',
    excerpt: '本次更新优化了移动端阅读页，汉化进度、更新进度与最新话入口更加直观，阅读更流畅。',
  },
];

export const testimonials = [
  {
    name: '阿衡',
    role: '热血漫忠实读者',
    content: '以前总怕错过更新，现在打开首页就能看到所有连载的同步更新进度和汉化进度，追更省心太多了。',
    avatar: 'https://readdy.ai/api/search-image?query=portrait%20of%20a%20young%20male%20reader%20smiling%20holding%20a%20comic%20magazine%2C%20warm%20natural%20light%2C%20clean%20minimal%20background%2C%20friendly%20anime%20style%20illustration&width=200&height=200&seq=avatar-01&orientation=squarish',
  },
  {
    name: '小眠',
    role: '恋爱漫爱好者',
    content: '汉化进度查询太实用了，什么时候能看到最新话心里有底，更新日历也很贴心，会一直用下去。',
    avatar: 'https://readdy.ai/api/search-image?query=portrait%20of%20a%20young%20female%20reader%20with%20soft%20smile%2C%20warm%20lighting%2C%20clean%20background%2C%20gentle%20anime%20style%20illustration&width=200&height=200&seq=avatar-02&orientation=squarish',
  },
  {
    name: '北辰',
    role: '科幻漫收藏党',
    content: '抢先看功能真的香，热门连载刚更新我就能第一时间看到，追更进度同步得又快又准。',
    avatar: 'https://readdy.ai/api/search-image?query=portrait%20of%20a%20young%20man%20wearing%20glasses%20smiling%2C%20warm%20background%2C%20casual%20clothing%2C%20anime%20style%20illustration&width=200&height=200&seq=avatar-03&orientation=squarish',
  },
];

export const faqs = [
  {
    q: '如何查看漫画的同步更新进度与汉化进度？',
    a: '进入任意漫画详情页，即可看到“同步更新进度”和“汉化进度”两个进度条。更新进度代表该作品在平台上的更新是否同步到最新话，汉化进度则代表最新话的中文翻译完成比例，一目了然。',
  },
  {
    q: '什么是“抢先看”？如何第一时间看到最新话？',
    a: '“抢先看”是平台为热门连载提供的及时更新栏目。最新话上线后，会第一时间出现在首页“今日更新”和对应漫画详情页的最顶端，无需刷新即可同步看到最新内容。',
  },
  {
    q: '汉化进度慢时我该怎么办？',
    a: '每部作品的汉化进度都由创作团队自主排期，你可以在漫画详情页关注进度条的变化。平台会优先同步已汉化完成的最新话，避免追更等待。',
  },
  {
    q: '订阅更新提醒后如何收到通知？',
    a: '目前可通过在漫画详情页关注作品，并在个人设置中开启更新通知。每次该作品更新或汉化进度推进时，都会收到提醒，不再错过任何一话。',
  },
  {
    q: '网站支持哪些设备访问？',
    a: '策驰漫画网采用响应式设计，支持电脑、平板和手机访问。移动端导航与阅读体验已针对性优化，追更进度与最新话入口在手机上同样直观。',
  },
  {
    q: '如何反馈更新问题或建议新作品上架？',
    a: '你可以通过页面底部或“关于我们”页面的联系方式与我们取得联系。我们会认真对待每一条建议，持续优化更新同步与汉化进度体验。',
  },
];

export const navLinks = [
  { label: '首页', to: '/' },
  { label: '漫画库', to: '/comics' },
  { label: '追更榜', to: '/rank' },
  { label: '常见问题', to: '/faq' },
  { label: '关于我们', to: '/about' },
];

export const siteStats = [
  { value: '1200+', label: '收录漫画' },
  { value: '80万', label: '追更用户' },
  { value: '98%', label: '更新同步率' },
  { value: '24h', label: '更新提醒' },
];